import { Icon, type IconName } from '../icons/Icon';

export type StateTone = 'ok' | 'att' | 'crit' | 'info' | 'off' | 'unk' | 'maint' | 'sel';

/** Fixed glyph per tone: the shape tells the state even without colour (black-and-white test). */
const GLYPH: Record<StateTone, IconName> = {
  ok: 'check',
  att: 'warning',
  crit: 'alertCircle',
  info: 'info',
  off: 'offline',
  unk: 'question',
  maint: 'wrench',
  sel: 'target',
};

interface StateBadgeProps {
  tone: StateTone;
  /** Translated word. Never empty: a state is colour + glyph + text (rule 1). */
  label: string;
  className?: string;
  /** Dense rows and card footers: the same colour, glyph and word without the border. */
  bare?: boolean;
}

/** The only component allowed to show a state in the whole application. */
export function StateBadge({ tone, label, className, bare = false }: StateBadgeProps) {
  const classes = ['badge', tone, bare ? 'bare' : '', className].filter(Boolean).join(' ');
  return (
    <span className={classes} data-tone={tone}>
      <Icon name={GLYPH[tone]} size={12} />
      {label}
    </span>
  );
}
